<template>
    <el-form v-if="model" ref="form" :model="model" :rules="rules" label-width="180px">
        <el-form-item label="原密码" prop="password_hash">
            <el-input type="password" v-model="model.password_hash" placeholder="原密码" show-password clearable></el-input>
        </el-form-item>
        <el-form-item label="设置新密码" prop="new_password">
            <el-input type="password" v-model="model.new_password" placeholder="设置新密码" show-password clearable></el-input>
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirm_password">
            <el-input type="password" v-model="model.confirm_password" placeholder="确认新密码" show-password clearable></el-input>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="submitForm()">确认</el-button>
            <el-button v-if="scenario == 'create'" @click="resetForm()">重置</el-button>
        </el-form-item>
    </el-form>
</template>
<script>
    export default {
        name: "subChangePwdForm",
        data() {
            /*
            *重复密码校验
            */
            let validateConfirmPwd = (rule, value, callback) => {
                if(!value){
                    callback(new Error('请再次输入确认密码'));
                }
                if (value != this.model.new_password) {
                    callback(new Error('两次密码输入不一致'))
                }
                if (value == this.model.password_hash) {
                    callback(new Error('新密码和原密码相同'))
                }
                callback()
            };

            //密码校验
            let validateNewPwd = (rule, value, callback) => {
                if (/^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$)([^\u4e00-\u9fa5\s]){6,12}$/g.test(value)) {
                    callback()
                } else {
                    callback(new Error('请输入包含英文字母和数字 6-12 位组合'))
                }
            }

            return {
                // 是否是业务员
                isBusiness: false,
                roles: [],
                rules: {
                    password_hash: [
                        {
                            required: true,
                            message: "原密码不允许为空",
                            trigger: "blur"
                        },
                        {
                            min: 6,
                            max: 12,
                            message: "密码长度最小6位最大不超过12位"
                        }
                    ],
                    new_password: [
                        {
                            required: true,
                            message: "新密码不允许为空",
                            trigger: "blur"
                        },
                        {
                            min: 6,
                            max: 12,
                            message: "密码长度最小6位最大不超过12位"
                        },
                        {
                            validator: validateNewPwd,
                            trigger: 'change'
                        }
                    ],
                    confirm_password: [
                        {
                            required: true,
                            message: "确认新密码不允许为空",
                            trigger: "blur"
                        },
                        {
                            min: 6,
                            max: 12,
                            message: "密码长度最小6位最大不超过12位"
                        },
                        {
                            validator: validateConfirmPwd,
                            trigger: 'change'
                        }
                    ]
                }
            };
        },
        props: {
            model: {
                type: Object,
                required: true,
            },
            scenario: {
                type: String,
                required: true
            }
        },
        created() {
            if (this.scenario == "update") {
                // 编辑时密码可以为空
                this.rules.password_hash.splice(0, 1);
            }
        },
        watch: {
        },
        methods: {


            //提交表单
            submitForm() {
                this.$refs["form"].validate(valid => {
                    if (valid) {
                        this.$emit("submit", this.model);
                    } else {
                        return false;
                    }
                });
            },

            // 重置表单
            resetForm() {
                this.$refs["form"].resetFields();
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/views/user/changePwdForm.vue